import { ENV } from '@/config/env';

export const executeReCaptcha = (): Promise<string> =>
  new Promise((resolve, reject) => {
    if (typeof window === 'undefined' || !window.grecaptcha) {
      reject(new Error('reCAPTCHA is not loaded'));
      return;
    }

    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha?.execute(ENV.GOOGLE_SITE_KEY || '', { action: 'submit' });

        resolve(token || '');
      } catch (error) {
        reject(new Error('Failed to execute reCAPTCHA'));
      }
    });
  });
